import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

@Index('unique_rbac_role_name', ['module', 'name'], { unique: true })
@Entity('_migration')
export class MigrationEntity extends BaseEntity {
	@Column('varchar', { name: '_module', length: 64 })
	public module!: string;

	@Column('varchar', { name: '_name', length: 64 })
	public name!: string;

	@Column('datetime', { name: '_completed_date', nullable: true })
	public completedDate!: Date | null;

	@Column('text', { name: '_error', nullable: true })
	public error!: string | null;

	@Column('longtext', { name: '_definition', nullable: true })
	public definition!: string | null;
}
